'use strict';

var React = require('react'),
    ClassNameMixin = require('../mixins/ClassNameMixin'),
    escapeTextContentForBrowser = require('react/lib/escapeTextContentForBrowser'),
    KeyCodes = require('../constants/KeyCodes'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    { isIE } = require('../utils/Browser'),
    { PropTypes } = React;

require('./ContentEditable.less');

/**
 * This component is purposefully uncontrolled
 * to prevent caret jumps and other weird browser behavior.
 */
var ContentEditable = React.createClass({
  mixins: [ClassNameMixin, PureRenderMixin],

  propTypes: {
    component: PropTypes.any,
    onChange: PropTypes.func.isRequired,
    text: PropTypes.string,
    placeholder: PropTypes.string,
    editable: PropTypes.bool,
    allowReturn: PropTypes.bool,
    maxLength: PropTypes.number,
    onMouseEnter: PropTypes.func,
    onMouseLeave: PropTypes.func
  },

  getDefaultProps() {
    return {
      component: 'div',
      editable: false,
      allowReturn: false,
      text: '',
      maxLength: Infinity
    };
  },

  getCSSModifiers() {
    return [this.props.editable && 'editable'];
  },

  getInitialState() {
    return {
      initialText: this.props.text
    };
  },

  componentWillReceiveProps(nextProps) {
    if (nextProps.editable && !this.props.editable) {
      this.setState({
        initialText: nextProps.text
      });
    }
  },

  componentWillUpdate(nextProps) {
    if (!nextProps.editable && this.props.editable) {
      this.getDOMNode().innerHTML = escapeTextContentForBrowser(this.state.initialText);
    }
  },

  componentDidMount() {
    if (isIE() && typeof MutationObserver !== 'undefined') {
      this.observer = new MutationObserver(this.handleChange);
      this.observer.observe(this.getDOMNode(), {
        attributes: true,
        childList: true,
        characterData: true,
        characterDataOldValue: true,
        subtree: true
      });
    }
  },

  componentWillUnmount() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  },

  render() {
    var html = escapeTextContentForBrowser(this.props.editable ?
      this.state.initialText :
      this.props.text
    );

    var Component = this.props.component;
    return (
      <Component className={this.getClassName()}
                 onInput={this.handleChange}
                 onBlur={this.handleBlur}
                 onFocus={this.handleFocus}
                 onKeyPress={this.handleKeyPress}
                 contentEditable={this.props.editable}
                 data-placeholder={this.props.placeholder}
                 dangerouslySetInnerHTML={{__html: html}}
                 onMouseEnter={this.props.onMouseEnter}
                 onMouseLeave={this.props.onMouseLeave} />
    );
  },

  handleFocus(e) {
    if (this.props.onFocus) {
      this.props.onFocus(e);
    }

    this.handleChange();
  },

  handleBlur(e) {
    if (e.target.textContent.length > this.props.maxLength) {
      e.target.innerHTML = e.target.textContent.substr(0, this.props.maxLength);
      this.props.onChange(e.target.textContent);
    }

    if (this.props.onBlur) {
      this.props.onBlur(e);
    }
  },

  handleChange() {
    var node = this.getDOMNode();

    if (!node.textContent.trim().length) {
      node.innerHTML = '';
    }

    this.props.onChange(node.textContent);
  },

  handleKeyPress(e) {
    if (e.which === KeyCodes.ENTER) {
      e.preventDefault();
    }

    if (e.target.textContent.length >= this.props.maxLength &&
        document.getSelection().toString().length === 0) {

      e.preventDefault();
    }
  }
});

module.exports = ContentEditable;


/** WEBPACK FOOTER **
 ** ./atoms/ContentEditable.jsx
 **/